import { BenefitStatus } from '../types/customer';

export const BENEFIT_STATUS_LABEL: Record<BenefitStatus, string> = {
  pending: 'Pendente',
  active: 'Ativo',
  suspended: 'Suspenso',
  cancelled: 'Cancelado',
  opted_out: 'Cancelado pelo Cliente ou Admin',
};
